import { DetailController } from './DetailController';

/** @ngInject */
export class DetailDialogController extends DetailController {
    constructor($scope, userService, arsMainDependencies, restUrl, service) {
        super($scope, userService, arsMainDependencies, restUrl, service);
        this.$scope.controller = this;
        this.modal = arsMainDependencies.$mdDialog;
        this.$scope.$on('master-check-box-fired', () => this.$scope.detailForm.$setDirty());
    }

    getId() {
        return this.state._params.id;
    }

    // db update/create
    create() {
        if (this.$scope.detailForm.$valid) {
            return super.create().then(() => this.closeDialog());
        } else {
            this.infoPop('MISSING_MANDATORY');
        }
    }

    // db update/create
    update() {
        if (this.$scope.detailForm.$valid) {
            return super.update().then(() => this.closeDialog());
        } else {
            this.infoPop('MISSING_MANDATORY');
        }
    }

    // db delete/logical deletion
    delete(ids) {
        return super.delete(ids).then((data) => {
            if (data) {
                this.infoPop(this.state._params.deleteConfirmation || 'DELETE_SUCCESS'); // inform the user
            } // error handled in parent
            this.closeDialog();
        });
    }

    closeDialog() {
        if(this.state.params.editMode && this.state.params.editMode === 'view') {
            // Deletion from detailview
            this.state.go(this.state.params.listView);
        }else {
            this.modal.cancel();
            this.state.reload();
        }
    }
}
